import { useTranslation } from "react-i18next";

const InitializeOptionsLists = () => {
  const { t } = useTranslation();

  const optionsListChooseListScope = [
    { text: t("field.options_choose"), value: "disabled", disabled: true },
    { text: t("field.options_full_list"), value: "yes" },
    { text: t("field.options.partial_list"), value: "no" },
  ];

  const optionsHasManagerList = [
    {
      text: t("field.have_list_managers"),
      value: "disabled",
      disabled: true,
    },
    { text: t("field.yes"), value: "yes" },
    { text: t("field.no"), value: "no" },
  ];

  const optionsManagerInvitesEmployees = [
    {
      text: t("field.will_managers_add_employees"),
      value: "disabled",
      disabled: true,
    },
    { text: t("field.yes"), value: "yes" },
    { text: t("field.no"), value: "no" },
  ];

  const availableManagerFields = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Email", value: "email" },
    { text: "Language", value: "language" },
  ];

  const availableEmployeeFields = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Email", value: "email" },
    { text: "Manager Emails", value: "manager_emails" },
    { text: "Language", value: "language" },
  ];

  return {
    optionsListChooseListScope,
    optionsHasManagerList,
    optionsManagerInvitesEmployees,
    availableManagerFields,
    availableEmployeeFields,
  };
};

export default InitializeOptionsLists;
